import { useMemo } from 'react';
import { api } from '@/redux/api';
import { useCurrentUnit } from './use-current-unit';

export const useCurrentCalls = () => {
  const { data: unit } = useCurrentUnit();

  const unitId = unit?.id ?? -1;

  const result = api.useGetCallsQuery(
    { unitId },
    {
      skip: unitId === -1,
    },
  );

  const data = useMemo(() => result.data ?? [], [result.data]);

  return { ...result, data };
};
